module.exports = __webpack_public_path__ + "img/profgrams.2edbe696.svg";